// Function to update the product display based on excavator parameter
function updateProductDisplay() {
  const container = document.getElementById('digb-range-tonne-sections');
  const jsonUrl = container.getAttribute('data-json-url');

  fetch(jsonUrl)
    .then(response => response.json())
    .then(data => {
      // Clear the container
      container.innerHTML = '';

      // Get the excavator parameter from URL
      const urlParams = new URLSearchParams(window.location.search);
      const excavatorParam = urlParams.get('excavator');
      
      // Check if the excavator parameter exists in the data
      if (excavatorParam && data && data[0] && data[0][excavatorParam]) {
        const excavatorData = data[0][excavatorParam];
        
        // Create a container for the section
        const sectionContainer = document.createElement('div');
        sectionContainer.className = 'digb-range-tonne-sections-container';
        
        // Add title for the excavator type
        const title = document.createElement('h2');
        title.className = 'digb-range-tonne-sections-title';
        title.textContent = excavatorData.title || `Products for ${excavatorParam.replace(/_/g, ' ')}`;
        sectionContainer.appendChild(title);

        // Loop through each section array in the excavator data
        excavatorData.sections.forEach(sectionArray => {
          // Loop through each section category in the array
          for (const sectionName in sectionArray) {
            if (sectionArray.hasOwnProperty(sectionName)) {
              const sectionData = sectionArray[sectionName];
              
              // Skip empty sections
              if (sectionData && sectionData.length > 0) {
                // Create section container
                const productSection = document.createElement('div');
                productSection.className = 'product-section';
                
                // Add section title
                const sectionTitle = document.createElement('h3');
                sectionTitle.className = 'product-section-title';
                sectionTitle.textContent = sectionName;
                productSection.appendChild(sectionTitle);

                // Create products grid
                const productsGrid = document.createElement('div');
                productsGrid.className = 'products-grid';
                
                // Add products to the grid
                sectionData.forEach(product => {
                  const productCard = document.createElement('div');
                  productCard.className = 'product-card image-blend';
                  
                  // Create link for the image
                  const imageLink = document.createElement('a');
                  imageLink.href = product.url;
                  imageLink.target = '_blank';
                  
                  const productImage = document.createElement('img');
                  productImage.className = 'product-image';
                  productImage.src = product.image_link || excavatorData.image;
                  productImage.alt = product.title || '';
                  productImage.loading = 'lazy';
                  
                  imageLink.appendChild(productImage);
                  
                  // Create link for the title
                  const titleLink = document.createElement('a');
                  titleLink.className = 'product-title-link';
                  titleLink.href = product.url;
                  titleLink.textContent = product.title;
                  titleLink.target = '_blank';
                  
                  productCard.appendChild(imageLink);
                  productCard.appendChild(titleLink);
                  productsGrid.appendChild(productCard);
                });
                
                productSection.appendChild(productsGrid);
                sectionContainer.appendChild(productSection);
              }
            }
          }
        });
        
        // Append the section container to the main container
        container.appendChild(sectionContainer);
      } else {
        // If no excavator parameter is provided or not found, show a message
        const message = document.createElement('div');
        message.textContent = 'Please specify an excavator type using the excavator parameter in the URL (e.g., ?excavator=tonnes_0-5_0-9_micro)';
        message.style.textAlign = 'center';
        message.style.padding = '20px';
        container.appendChild(message);
      }
    })
    .catch(error => {
      console.error('Error loading digb-range-tonne-sections data:', error);
      
      // Show error message in the container
      const errorDiv = document.createElement('div');
      errorDiv.textContent = 'Error loading product data.';
      errorDiv.style.textAlign = 'center';
      errorDiv.style.padding = '20px';
      errorDiv.style.color = 'red';
      document.getElementById('digb-range-tonne-sections').appendChild(errorDiv);
    });
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', updateProductDisplay);

// Listen for URL changes (when using history.pushState, which is likely used by the tonne-selector)
let currentUrl = location.href;
new MutationObserver(() => {
  if (location.href !== currentUrl) {
    currentUrl = location.href;
    updateProductDisplay();
  }
}).observe(document, { subtree: true, childList: true });

// Also listen for popstate event in case the user uses browser navigation
window.addEventListener('popstate', updateProductDisplay);

// Listen for custom excavator selection event (in case the tonne-selector dispatches one)
document.addEventListener('excavatorSelected', function(e) {
  updateProductDisplay();
});